<template>
  <div>
    <div v-show="loading">
      <loading-spinner v-show="loading" />
    </div>
    <div v-show="!loading">
      <b-container>
        <b-row>
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentName">Name:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentName"
              v-model.trim="alternativePayment.name"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentProdIdAlias">Product ID Alias:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentProdIdAlias"
              v-model.trim="alternativePayment.prodAliasId"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentWSGAccess">WSG Access:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentWSGAccess"
              v-model.trim="alternativePayment.wsgAccess"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentWSGURL">WSG URL:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentWSGURL"
              v-model.trim="alternativePayment.wsgUrl"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentWSGUser">WSG User:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentWSGUser"
              v-model.trim="alternativePayment.wsgUser"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <br>
        <b-row v-show="isApplePayment">
          <b-col cols="12">
            <h5>Apple Pay Settings</h5>
          </b-col>
        </b-row>
        <b-row v-show="isApplePayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentMerchantId">Merchant ID:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentMerchantId"
              v-model.trim="alternativePayment.merchantId"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isApplePayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentInitiativeContext">Initiative Context:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentInitiativeContext"
              v-model.trim="alternativePayment.initiativeContext"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isApplePayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentSellerName">Seller Name:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentSellerName"
              v-model.trim="alternativePayment.sellerName"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isApplePayment">
          <b-col cols="2" />
          <b-col cols="10">
            <b-form-checkbox
              id="alternativePaymentShowAmount"
              v-model="alternativePayment.showAmount"
              size="sm"
              plain
            >
              Show amount
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-show="isAmazonPayment">
          <b-col cols="12">
            <h5>Amazon Pay Settings</h5>
          </b-col>
        </b-row>
        <b-row v-show="isAmazonPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentAuthToken">Auth Token:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentAuthToken"
              v-model.trim="alternativePayment.authToken"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isAmazonPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentKeyId">Key ID:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentKeyId"
              v-model.trim="alternativePayment.keyId"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isAmazonPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentMerchantId">Merchant ID:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentMerchantId"
              v-model.trim="alternativePayment.merchantId"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isAmazonPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentSecretKey">Secret Key:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentSecretKey"
              v-model.trim="alternativePayment.secretKey"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isAmazonPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentMWSAuthToken">MWS Auth Token:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentMWSAuthToken"
              v-model.trim="alternativePayment.mwsAuthToken"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isAmazonPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentClientId">Client ID:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentClientId"
              v-model.trim="alternativePayment.amazonClientId"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isAmazonPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentPlatformId">Platform ID:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentPlatformId"
              v-model.trim="alternativePayment.platformId"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isAmazonPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentStoreName">Store Name:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentStoreName"
              v-model.trim="alternativePayment.storeName"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isAmazonPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentSellerId">Seller ID:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentSellerId"
              v-model.trim="alternativePayment.sellerId"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isAmazonPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentEnvironment">Environment:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentEnvironment"
              v-model.trim="alternativePayment.environment"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isPayPalPayment">
          <b-col cols="12">
            <h5>PayPal Settings</h5>
          </b-col>
        </b-row>
        <b-row v-show="isPayPalPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentMerchantId">Merchant ID:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentMerchantId"
              v-model.trim="alternativePayment.merchantId"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isPayPalPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentKeyId">Key ID:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentKeyId"
              v-model.trim="alternativePayment.keyId"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isPayPalPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentSecretKey">Secret Key:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentSecretKey"
              v-model.trim="alternativePayment.secretKey"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isPayPalPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentPaymentURL">Payment URL:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentPaymentURL"
              v-model.trim="alternativePayment.paymentUrl"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isPayPalPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentReturnURL">Return URL:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentReturnURL"
              v-model.trim="alternativePayment.returnUrl"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-show="isPayPalPayment">
          <b-col
            cols="2"
            align="right"
          >
            <label for="alternativePaymentCancelURL">Cancel URL:</label>
          </b-col>
          <b-col cols="10">
            <b-form-input
              id="alternativePaymentCancelURL"
              v-model.trim="alternativePayment.cancelUrl"
              size="sm"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2" />
          <b-col cols="10">
            <b-form-checkbox
              id="alternativePaymentAddressSuppressed"
              v-model="alternativePayment.addressSuppressed"
              size="sm"
              plain
            >
              Suppress shipping address
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-show="isPayPalPayment">
          <b-col cols="2" />
          <b-col cols="10">
            <b-form-checkbox
              id="alternativePaymentVenmo"
              v-model="alternativePayment.venmo"
              size="sm"
              plain
            >
              Suppress Venmo Button
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-show="isPayPalPayment">
          <b-col cols="2" />
          <b-col cols="10">
            <b-form-checkbox
              id="alternativePaymentPayLater"
              v-model="alternativePayment.payLater"
              size="sm"
              plain
            >
              Suppress PayLater Button
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-show="isPayPalPayment">
          <b-col cols="2" />
          <b-col cols="10">
            <b-form-checkbox
              id="alternativePaymentCredit"
              v-model="alternativePayment.credit"
              size="sm"
              plain
            >
              Suppress Credit Button
            </b-form-checkbox>
          </b-col>
        </b-row>
        <br>
        <b-row v-show="!isApplePayment">
          <b-col cols="1">
            <label for="altPay-Version">Version:</label>
          </b-col>
          <b-col cols="2">
            <b-form-select
              id="alternativePaymentVersion"
              v-model="alternativePayment.version"
              :options="altPayVersion"
              size="sm"
              plain
            />
          </b-col>
          <b-col cols="3">
            <b-form-checkbox
              id="alternativePaymentOnboardComplete"
              v-model="alternativePayment.onboardComplete"
              size="sm"
              plain
            >
              Onboarding Completed
            </b-form-checkbox>
          </b-col>
        </b-row>
        <br>
        <br>
        <b-row>
          <b-col cols="10">
            <b-alert
              :color="success? 'success': 'danger'"
              :variant="success? 'success': 'danger'"
              :show="showMsg"
            >
              {{ msg }}
            </b-alert>
          </b-col>
          <b-col cols="2">
            <b-button
              variant="primary"
              @click="saveData"
            >
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import { dataAPI } from '../services/DataAPI'
import LoadingSpinner from '../UIComponents/LoadingSpinner'

export default {
  name: 'EditAlternativePaymentItem',
  components: {
    LoadingSpinner
  },
  props: {
    paymentType: {
      type: String,
      required: true
    },
    paymentId: {
      type: String,
      required: false,
      default: null
    },
    clientId: {
      type: String,
      required: false,
      default: null
    },
    configurationId: {
      type: String,
      required: false,
      default: null
    },
    alternativePayment: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      showMsg: false,
      success: true,
      isApplePayment: this.paymentType === 'APPLE',
      isAmazonPayment: this.paymentType === 'AMAZON',
      isPayPalPayment: this.paymentType === 'PAYPAL',
      msg: ''
    }
  },
  computed: {
    currentUserToken() {
      return this.$store.state.auth.userToken
    },
    altPayVersion() {
      return this.alternativePayment.onboardComplete ? [{ text: '1', value: 1 }, { text: '2', value: 2 }] : [{ text: '1', value: 1 }]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const vm = this
      if (this.paymentId) {
        this.loading = true
        dataAPI(vm.currentUserToken)
          .getPaymentById(this.paymentType, this.paymentId, this.clientId, this.configurationId)
          .then((data) => {
            vm.loading = false
            vm.alternativePayment = data
            vm.alternativePayment.version = data?.version || 1
          })
      }
    },
    saveData() {
      const vm = this
      vm.loading = true
      vm.showMsg = false
      if (this.configurationId) {
        this.alternativePayment.configurationId = this.configurationId
      } else {
        this.alternativePayment.clientId = this.clientId
      }
      this.alternativePayment.processor = this.paymentType
      // check if the onboarding is not completed or the amazon auth token is not set we default the version to 1
      if (!this.alternativePayment.onboardComplete || (!this.alternativePayment.authToken && this.alternativePayment.processor === 'AMAZON')) {
        this.alternativePayment.version = 1
      }
      dataAPI(vm.currentUserToken)
        .updateAlternativePayment(this.alternativePayment)
        .then(() => {
          vm.showMsg = true
          vm.success = true
          vm.msg = 'Saved alternative payment.'
          vm.loading = false
        }).catch((error) => {
          vm.loading = false
          vm.showMsg = true
          vm.success = false
          vm.msg = 'Failed to save alternative payment: ' + error.message
        })
    }
  }
}
</script>
